import React from "react";
import LegalLayout from "../components/legal/LegalLayout";

export default function DeleteAccountPage() {
  return (
    <LegalLayout
      title={
        <>
          ClearBadge{"\u2122"} <span className="legal-title-gradient">Delete Account</span>
        </>
      }
      intro="Request deletion of your ClearBadge account or selected personal data associated with your ClearBadge use."
      eyebrow="Account Support"
    >
      <article className="legal-card" aria-label="ClearBadge account deletion instructions">
        <section className="legal-section" id="delete-request-options">
          <p>
            You may request either:
          </p>
          <ul>
            <li>Deletion of your full ClearBadge account and associated data</li>
            <li>Deletion of specific data collected through ClearBadge without deleting your entire account</li>
          </ul>
        </section>

        <section className="legal-section" id="delete-account">
          <p>
            To request deletion of your ClearBadge account and associated data, email{" "}
            <a href="mailto:support@clearbadge.org?subject=ClearBadge%20Account%20Deletion%20Request">
              support@clearbadge.org
            </a>{" "}
            from the email address associated with your account.
          </p>
          <ol>
            <li>Email support@clearbadge.org from the email associated with your account.</li>
            <li>Use the subject line: &quot;ClearBadge Account Deletion Request&quot;.</li>
            <li>Include any details needed to identify your account.</li>
          </ol>
          <p>
            ClearBadge will review and process deletion requests as required by applicable policy, legal obligations,
            and security requirements.
          </p>
        </section>

        <section className="legal-section" id="delete-selected-data">
          <h2>Request Deletion Of Specific Data</h2>
          <p>
            If you want to delete specific data without deleting your full account, email{" "}
            <a href="mailto:support@clearbadge.org?subject=ClearBadge%20Data%20Deletion%20Request">
              support@clearbadge.org
            </a>{" "}
            from the email address associated with your account.
          </p>
          <ol>
            <li>Use the subject line: &quot;ClearBadge Data Deletion Request&quot;.</li>
            <li>Describe the specific data you want deleted.</li>
            <li>Include any details needed for ClearBadge to identify the relevant records.</li>
          </ol>
          <p>Examples of data you may request to delete include:</p>
          <ul>
            <li>Profile or contact information associated with your account</li>
            <li>Uploaded images or supporting license documents</li>
            <li>Inquiry submissions, notes, or other user-submitted content</li>
            <li>Other account-associated data, where deletion is legally and technically permissible</li>
          </ul>
        </section>

        <section className="legal-section" id="delete-account-data-removed">
          <h2>What May Be Deleted</h2>
          <ul>
            <li>Account information such as name and email address</li>
            <li>Profile information and related account data</li>
            <li>User-submitted content associated with the account</li>
            <li>Selected records specifically identified in a valid partial-data deletion request</li>
          </ul>
        </section>

        <section className="legal-section" id="delete-account-retention">
          <h2>What May Be Retained</h2>
          <p>
            ClearBadge may retain minimal records where necessary for legal compliance, fraud prevention, billing,
            dispute resolution, or platform security.
          </p>
        </section>

        <section className="legal-section" id="delete-account-contact">
          <h2>Questions</h2>
          <p>
            If you have questions about account deletion or your data, contact{" "}
            <a href="mailto:support@clearbadge.org">support@clearbadge.org</a>.
          </p>
        </section>
      </article>
    </LegalLayout>
  );
}
